export default {
  // ACCENT COLOURS
  accentGrey: '#F8F8F8',
  accentWhite: '#CCCCCC',

  primary: '#00162b'
}
